import { PROJECTS_PLAZA_Z_RANGE } from "./poi";

// Shared deterministic-per-session building layout used for both rendering
// (City.jsx) and character collision (CharacterController.jsx) so the two
// never desync. Buildings are spaced generously so gaps between adjacent
// same-side buildings stay wider than the character, avoiding "celah" (gap)
// stuck-states, and the projects plaza z-range is kept fully clear.
export function generateBuildings(count) {
  const arr = [];
  const zStep = 6.2;
  let i = 0;
  let placed = 0;
  while (placed < count && i < count * 2) {
    const z = -i * zStep + 4;
    i += 1;
    if (z >= PROJECTS_PLAZA_Z_RANGE[0] && z <= PROJECTS_PLAZA_Z_RANGE[1]) continue;
    const side = placed % 2 === 0 ? -1 : 1;
    const x = side * (10 + Math.random() * 5);
    const h = 5 + Math.random() * 16;
    const w = 3 + Math.random() * 2.5;
    const d = 3 + Math.random() * 2.5;
    const color = placed % 3 === 0 ? "#FF007F" : "#01FFFF";
    arr.push({
      key: `b-${placed}`,
      position: [x, 0, z],
      size: [w, h, d],
      color,
    });
    placed += 1;
  }
  return arr;
}

// Simple 2D (XZ) AABB collision test, expanded by the character's radius.
export function checkBuildingCollision(x, z, radius, buildings) {
  if (!buildings) return false;
  for (const b of buildings) {
    const [bx, , bz] = b.position;
    const [w, , d] = b.size;
    const halfW = w / 2 + radius;
    const halfD = d / 2 + radius;
    if (Math.abs(x - bx) < halfW && Math.abs(z - bz) < halfD) {
      return true;
    }
  }
  return false;
}
